/**
 * Respuestas tipo { success: true, message: "...", data?: ... } del backend.
 */
export function parseApiSuccessEnvelope(data) {
  if (!data || typeof data !== 'object') {
    return { success: false, message: '' }
  }
  return {
    success: data.success === true,
    message: typeof data.message === 'string' ? data.message : ''
  }
}

/** Extrae el recurso embebido (p. ej. cita) del cuerpo JSON. */
export function extractNestedResource(data, keys = ['data', 'appointment']) {
  if (!data || typeof data !== 'object') return null
  for (const k of keys) {
    const v = data[k]
    if (v && typeof v === 'object') return v
  }
  if ('id' in data && (data.appointment_date || data.date)) return data
  return null
}
